import apiClient from '../apiClient';
import { GET_TRANSPORTATION_UNIT_BY_SERVICE_ITEM_ID_URL } from '../apiUrl';

const getTransportationUnitByServiceItemIdApi = Id => {
  return apiClient.get(GET_TRANSPORTATION_UNIT_BY_SERVICE_ITEM_ID_URL(Id));
};

export default getTransportationUnitByServiceItemIdApi;
